import { cn } from "@/lib/utils";

export default function SectionHeader({ title, kicker, action, className }) {
  return (
    <div className={cn("flex items-end justify-between mb-4", className)}>
      <div>
        {kicker && (
          <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/40 mb-1">
            {kicker}
          </div>
        )}
        <h2 className="font-display text-xl text-white">{title}</h2>
      </div>
      {action}
    </div>
  );
}
